import { useContext } from 'react';
import { ApptRequestsIvContext } from './context';

export const useApptRequestsIv = () => {
  const context = useContext(ApptRequestsIvContext);

  if (!context) throw new Error('useApptRequestsIv must be used within a ApptRequestsIvProvider');

  return context;
};
